'use strict';
/** family: Progress **/
var __extends =
	(this && this.__extends) ||
	(function () {
		var extendStatics = function (d, b) {
			extendStatics =
				Object.setPrototypeOf ||
				({ __proto__: [] } instanceof Array &&
					function (d, b) {
						d.__proto__ = b;
					}) ||
				function (d, b) {
					for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
				};
			return extendStatics(d, b);
		};
		return function (d, b) {
			extendStatics(d, b);
			function __() {
				this.constructor = d;
			}
			d.prototype =
				b === null
					? Object.create(b)
					: ((__.prototype = b.prototype), new __());
		};
	})();
var __assign =
	(this && this.__assign) ||
	function () {
		__assign =
			Object.assign ||
			function (t) {
				for (var s, i = 1, n = arguments.length; i < n; i++) {
					s = arguments[i];
					for (var p in s)
						if (Object.prototype.hasOwnProperty.call(s, p))
							t[p] = s[p];
				}
				return t;
			};
		return __assign.apply(this, arguments);
	};
var __rest =
	(this && this.__rest) ||
	function (s, e) {
		var t = {};
		for (var p in s)
			if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
				t[p] = s[p];
		if (s != null && typeof Object.getOwnPropertySymbols === 'function')
			for (
				var i = 0, p = Object.getOwnPropertySymbols(s);
				i < p.length;
				i++
			)
				if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
		return t;
	};
Object.defineProperty(exports, '__esModule', { value: true });
var classNames = require('classnames');
var React = require('react');
var prop_types_1 = require('../../types/prop.types');
var CLASS_NAME = 'i-progress-bar';
var ProgressBar = /** @class */ (function (_super) {
	__extends(ProgressBar, _super);
	function ProgressBar() {
		var _this = (_super !== null && _super.apply(this, arguments)) || this;
		_this.renderProgressBar = function (_a) {
			var animated = _a.animated,
				className = _a.className,
				color = _a.color,
				label = _a.label,
				max = _a.max,
				min = _a.min,
				now = _a.now,
				striped = _a.striped,
				style = _a.style,
				restProps = __rest(_a, [
					'animated',
					'className',
					'color',
					'label',
					'max',
					'min',
					'now',
					'striped',
					'style',
				]);
			var _b;
			return React.createElement(
				'div',
				__assign(
					{
						'aria-valuemax': max,
						'aria-valuemin': min,
						'aria-valuenow': now,
						className: classNames(
							className,
							'progress-bar',
							((_b = {
								'progress-bar-animated': animated,
								'progress-bar-striped': animated || striped,
							}),
							(_b['bg-' + color] = !!color),
							_b)
						),
						role: 'progressbar',
						style: __assign(
							{ width: ((now - min) / (max - min)) * 100 + '%' },
							style
						),
					},
					restProps
				),
				label
			);
		};
		return _this;
	}
	ProgressBar.prototype.render = function () {
		var _a = this.props,
			animated = _a.animated,
			className = _a.className,
			children = _a.children,
			color = _a.color,
			label = _a.label,
			max = _a.max,
			min = _a.min,
			now = _a.now,
			stacked = _a.stacked,
			striped = _a.striped,
			restProps = __rest(_a, [
				'animated',
				'className',
				'children',
				'color',
				'label',
				'max',
				'min',
				'now',
				'stacked',
				'striped',
			]);
		return stacked
			? this.renderProgressBar(
					__assign(
						{
							animated: animated,
							className: className,
							color: color,
							label: label,
							max: max,
							min: min,
							now: now,
							striped: striped,
						},
						restProps
					)
			  )
			: React.createElement(
					'div',
					__assign(
						{
							className: classNames(
								CLASS_NAME,
								className,
								'progress'
							),
						},
						restProps
					),
					children
						? React.Children.map(children, function (child) {
								return React.cloneElement(child, {
									stacked: true,
								});
						  })
						: this.renderProgressBar({
								animated: animated,
								color: color,
								label: label,
								max: max,
								min: min,
								now: now,
								striped: striped,
						  })
			  );
	};
	ProgressBar.Color = prop_types_1.ThemeColor;
	ProgressBar.defaultProps = {
		max: 100,
		min: 0,
		now: 0,
	};
	return ProgressBar;
})(React.Component);
exports.ProgressBar = ProgressBar;
//# sourceMappingURL=ProgressBar.js.map
